module.exports = __webpack_public_path__ + "static/media/results.644656ef.svg";